$(function(){
    function realisation_ajax(page,cat,action){

        $page = page || 1;
        $.ajax({
            url: "/wp/wp-admin/admin-ajax.php",
            data: ({action : 'realisation_ajax', page: $page, cat: cat}),
            type: "post",
            success: function(data){
                var $block = $('.block--realisation-ajax');
                var json_data = JSON.parse(data);
                //When all articles are shown, removing the input
                if($page >= json_data.nb_pages){
                    $(".realisation__list-button").hide();
                }else{
                    $(".realisation__list-button").show();
                }
                //
                if(action === false){
                    $block.append(json_data.html);
                }else if(action === true){
                    $block.html(json_data.html);
                }
                    
            },
            error: gallery_error_handler
        });
    }

    function gallery_error_handler(jqXHR, textStatus, errorThrown){
        console.log("Erreur d'affichage");
    }

    $('body').on('click', '.realisation__list-button', function(e){
        e.preventDefault();
        var $real_btn = $(".realisation__list-button");
        var current_page = $real_btn.data("page");
        var next_page = current_page+1;
        $real_btn.data("page", next_page);
        //console.log(next_page);
        var current_cat = $(".realisation__filters-list li.is-active").data("category");
        //console.log(current_cat);
        
        realisation_ajax(next_page, current_cat, false);
    })

    $(document).on('click', ".ajax-li", function (evt) {
        var $el = $(this);
        var $active_filter = $(".realisation__filters-list li.is-active");
        //Pagination's back at first page
        $(".realisation__list-button").data("page",1);
        var $paged = $(".realisation__list-button").data("page");
        //Changing which category is currently active
        $active_filter.removeClass("is-active");
        $el.addClass("is-active");
       
        realisation_ajax($paged, $el.data('category'), true);
    });
});


// WEBPACK FOOTER //
// ../views/blocks/realisations/assets/script.js